import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useStyles from "./styles"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { closeDeleteOrgDialog } from "actions/delete-org-dialog"
import { deleteOrg } from "actions/organization"
import { Box } from "@material-ui/core"
import { openSnackBar } from "actions/snack-bar"
import { logout } from "actions/authentication"
import DialogsContainerDialog from "../DialogsContainer"
import LoaderButton from "../../components/LoaderButton"

const DeleteOrgDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const organization = useSelector(state => state.organization.currentOrg)
  const open = useSelector(state => state.deleteOrgDialog.open)
  const [working, setWorking] = useState(false)

  const handleClose = () => {
    dispatch(closeDeleteOrgDialog())
  }

  const removeOrg = () => {
    setWorking(true)
    dispatch(deleteOrg(organization.id))
      .then(() => {
        dispatch(
          openSnackBar({ message: "Your organization has been deleted" })
        )
        setTimeout(() => {
          dispatch(logout())
        }, 500)
      })
      .catch(err => {
        dispatch(openSnackBar({ message: "Error deleting organization" }))
        console.log(err)
      })
      .finally(() => {
        setWorking(false)
      })
  }
  return (
    <DialogsContainerDialog
      className={classes.deleteOrgDialog}
      open={open}
      handleClose={handleClose}
      title="Are you sure you want to delete your organization?"
      content={
        <Typography variant="caption" className={classes.explanationText}>
          This will cancel your organization's subscription and remove all
          account data. This operation is irreversable.
        </Typography>
      }
      buttons={
        <Box>
          <Button
            variant="text"
            className={classes.closeButton}
            onClick={handleClose}
          >
            cancel
          </Button>
          <LoaderButton
            onClick={removeOrg}
            working={working}
            variant="contained"
            classes={{ button: classes.removeButton }}
          >
            Delete My Organization
          </LoaderButton>
        </Box>
      }
      fullScreen={false}
    />
  )
}

export default DeleteOrgDialog



// WEBPACK FOOTER //
// ./src/dialogs/DeleteOrg/index.jsx